<div class="flex flex-row justify-center items-center">
  <span class="text-xs"
    >Copyright &copy; {{ currentYear }} Brick River Lab. All rights
    reserved</span
  >
</div>
